var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7188 17.2812V34.7812L50.7188 43.6875L48.2188 47.9062L30.7188 37.2812V17.2812H35.7188ZM15.0938 52.9062C20.4062 58.1146 26.7083 60.7188 34 60.7188C41.2917 60.7188 47.5417 58.1146 52.75 52.9062C58.0625 47.5938 60.7188 41.2917 60.7188 34C60.7188 26.7083 58.0625 20.4583 52.75 15.25C47.5417 9.9375 41.2917 7.28125 34 7.28125C26.7083 7.28125 20.4062 9.9375 15.0938 15.25C9.88542 20.4583 7.28125 26.7083 7.28125 34C7.28125 41.2917 9.88542 47.5938 15.0938 52.9062ZM10.4062 10.5625C16.9688 4 24.8333 0.71875 34 0.71875C43.1667 0.71875 50.9792 4 57.4375 10.5625C64 17.0208 67.2812 24.8333 67.2812 34C67.2812 43.1667 64 51.0312 57.4375 57.5938C50.9792 64.0521 43.1667 67.2812 34 67.2812C24.8333 67.2812 16.9688 64.0521 10.4062 57.5938C3.94792 51.0312 0.71875 43.1667 0.71875 34C0.71875 24.8333 3.94792 17.0208 10.4062 10.5625Z",
    fill: "#FFB142"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.1601c2c3.svg";
export { ForwardRef as ReactComponent };